import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() type: string = 'button';
  @Input() classes: string = '';
  @Input() disabled: boolean = false;
  @Input() startIcon: string;
  @Input() endIcon: string;
  @Input() variant: 'primary' | 'theme' | 'dark' | 'danger' | 'link' = 'theme';
  @Input() customStyles: { [key: string]: string } = {};
}
